import React, { Component } from 'react';
import { Row, Col, Input, Modal, Select, DatePicker, Checkbox } from 'antd';
import $ from 'jquery';

const { TextArea } = Input;
const Option = Select.Option;
const { RangePicker } = DatePicker;

class EditLeave extends Component {

    constructor( props ){
        super( props );

        this.state = {
            visible                 : false,
            leave_type_id           : 0,
            leave_type_name         : 'none',
            leave_type_type         : '',
            leave_type_count        : 0,
            holiday                 : false,
            weekend                 : false,
            description             : '',
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );

    }

    handleOk = (e) => {

        if( this.state.leave_name === "" || this.state.leave_name === "none" ){
            this.setState({
                leave_name: ''
            });
            return false;
        }
        this.props.onSubmit( this.state );
        this.setState({ visible: false });
    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }
    

    componentWillReceiveProps( nextProps ){

        if( nextProps.data.length !== 0 ){

            this.setState({
                visible              : nextProps.onModel,
                leave_type_id        : nextProps.data.leave_type_id,
                leave_type_name      : nextProps.data.leave_type_name,
                leave_type_type      : nextProps.data.leave_type_type,
                leave_type_count     : nextProps.data.leave_type_count,
                holiday              : nextProps.data.holiday,
                weekend              : nextProps.data.weekend,
                description          : nextProps.data.description
            })
            
        }
    }


    render() {
        return (

            <Modal
                title="Edit Leave"
                maskClosable={ false }
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label  className={ ( this.state.leave_type_name === '') ? 'error': '' }>Name</label>
                        <Input className={ ( this.state.leave_type_name === '') ? 'br_error': '' } 
                            value={ this.state.leave_type_name }
                            onChange={ (e)=> this.setState({ leave_type_name: e.target.value }) } size="default"  />
                    </Col>
                </Row>

                <Row className="mrg_b_10" gutter={16}>
                    <Col span={ 12 }>
                        <label>Type</label>
                        <Select
                            value={ this.state.leave_type_type } 
                            onChange={ (value) => this.setState({ leave_type_type: value }) }
                            style={{ width: '100%' }} >
                            <Option key="paid">Paid</Option>
                            <Option key="unpaid">Unpaid</Option>
                        </Select>
                    </Col>
                    <Col span={ 12 }>
                        <label>Leave Count</label>
                        <Input 
                            value={ this.state.leave_type_count }
                            onChange={ (e) => this.setState({ leave_type_count: e.target.value }) } />
                    </Col>
                </Row>

                <Row className="mrg_b_10" gutter={16}>
                    <Col span={ 8 }>
                        <Checkbox 
                            checked={ JSON.parse( this.state.holiday ) }
                            onChange={ (e) => this.setState({ holiday: e.target.checked }) }
                            className="_center">Exclusive Holiday</Checkbox>
                    </Col>
                    <Col span={ 8 }>
                        <Checkbox 
                            checked={ JSON.parse( this.state.weekend ) }
                            onChange={ (e) => this.setState({ weekend: e.target.checked }) }
                            className="_center">Exclusive weekend</Checkbox>
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label>Description</label>
                        <TextArea 
                            value={ this.state.description }
                            onChange={ ( e ) => this.setState({ description: e.target.value }) }
                            rows={3} />
                    </Col>
                </Row>

            </Modal>

        )
    }
}

export default EditLeave


// WEBPACK FOOTER //
// ./src/pages/leave_type/childs/edit.leave.js